<template>
  <div>
    <Panel title="文件落地查询">
      <template slot="buttons">
        <el-button title="查询" class="blue" icon="el-icon-fa-search" @click="pageTable.handleLoad()">查询</el-button>
        <el-button title="重置" class="yellow" icon="el-icon-fa-refresh" @click="pageTable.handleReset()">重置</el-button>
      </template>
      <el-form :model="pageTable.param" ref="queryform">
        <el-row>
          <el-col :lg='6' :sm='12'>
            <el-form-item prop="ms_name" label="报文名称">
              <el-input v-model="pageTable.param.ms_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item prop="ms_content" label="报文内容">
              <el-input v-model="pageTable.param.ms_content"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item prop="ms_type" label="业务类型">
              <el-input v-model="pageTable.param.ms_type"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item label="传输类别" prop="sp_type">
              <el-select placeholder="请选择" v-model="pageTable.param.sp_type" clearable>
                <el-option v-for="item in translate" :key="item.value" :label="item.label"
                           :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item prop="ms_status" label="传输状态">
              <el-select v-model="pageTable.param.ms_status" filterable clearable placeholder="请选择">
                <el-option v-for="item in transOptions" :key="item.id" :label="item.text" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item prop="date" label="传输日期">
              <el-select v-model="pageTable.param.date" filterable>
                <el-option v-for="item in dateOptions"  :key="item.id" :label="item.text" :value="item.id"
                           :disabled="item.id === 'keepDays'"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item label="开始时间" style="height: 41px;">
              <el-row style="display: inline-block;">
                <el-col :span="10">
                  <el-select v-model="pageTable.param.start_time">
                    <el-option v-for="item in timeOptions" :key="item.id" :label="item.text"
                               :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2">
                  <span>&nbsp;时&nbsp;</span>
                </el-col>
                <el-col :span="10">
                  <el-select v-model="pageTable.param.start_minute">
                    <el-option v-for="item in minuteOptions" :key="item.id" :label="item.text"
                               :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2">
                  <span>&nbsp;分&nbsp;</span>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :lg='6' :sm='12'>
            <el-form-item label="结束时间" style="height: 41px;">
              <el-row style="display: inline-block;">
                <el-col :span="10">
                  <el-select v-model="pageTable.param.end_time">
                    <el-option v-for="item in timeOptions" :key="item.id" :label="item.text"
                               :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2">
                  <span>&nbsp;时&nbsp;</span>
                </el-col>
                <el-col :span="10">
                  <el-select v-model="pageTable.param.end_minute">
                    <el-option v-for="item in minuteOptions" :key="item.id" :label="item.text"
                               :value="item.id"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="2">
                  <span>&nbsp;分&nbsp;</span>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </Panel>

    <Panel title="文件落地列表">
      <template slot="buttons">
        <el-button title="删除选定" class="red" @click="doSeleDel" icon="el-icon-fa-trash">删除选定</el-button>
        <el-button title="选定重发" class="green" @click="doSeleReSend" icon="el-icon-fa-refresh">选定重发</el-button>
      </template>
      <el-table highlight-current-row stripe border :data="pageTable.data" v-loading="pageTable.isLoading"
                ref="table" @selection-change="handleSelectionChange" element-loading-spinner="el-icon-loading"
                element-loading-text="数据加载中" height="calc(100vh - 620px)">
        <el-table-column prop="$rownum" label="NO." width="40" align="center"/>
        <el-table-column type="selection" align='center' width="30"></el-table-column>
        <el-table-column label="下载" width="40" align="center" >
          <template slot-scope="scope">
            <el-button icon="el-icon-fa-download" @click="download(scope.$index,scope.row)"></el-button>
          </template>
        </el-table-column>
        <el-table-column label="二维码" width="50" align="center" >
          <template slot-scope="scope">
            <el-popover
              :ref="`popover-${scope.$index}`"
              width="500px"
              placement="right"
              trigger="click">
                <el-image
                  style="width: 300px; height: 300px;overflow: inherit;"
                  :src="QRCodeShow.url"
                  fit="cover" align="center"></el-image>
              <el-button icon="el-icon-fa-qrcode" @click="showQRcode(scope.$index,scope.row)"  slot="reference" ></el-button>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="报文名称" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-button type="primary" @click="fileContent(scope.$index, scope.row)">{{scope.row.msname}}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="传输方向" prop="sptype" align="center" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.sptype=== '申报'"><el-tag type="success">{{scope.row.sptype}}</el-tag></span>
            <span v-if="scope.row.sptype=== '回执'"><el-tag type="success">{{scope.row.sptype}}</el-tag></span>
            <span v-if="scope.row.sptype=== '未知'"><el-tag type="info">{{scope.row.sptype}}</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column label="报文处理状态" prop="msstatus" align="center" show-overflow-tooltip width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.msstatus=== '1'"><el-tag type="info">正在传输</el-tag></span>
            <span v-if="scope.row.msstatus=== '2'"><el-tag type="success">重发成功</el-tag></span>
            <span v-if="scope.row.msstatus=== '3'"><el-tag type="danger">传输失败</el-tag></span>
            <span v-if="scope.row.msstatus=== '4'"><el-tag type="info">回执处理</el-tag></span>
            <span v-if="scope.row.msstatus=== '5'"><el-tag type="success">传输成功</el-tag></span>
            <span v-if="scope.row.msstatus=== '6'"><el-tag type="info">已确认</el-tag></span>
            <span v-if="scope.row.msstatus=== '7'"><el-tag type="danger">未到达</el-tag></span>
            <span v-if="scope.row.msstatus=== '8'"><el-tag type="warning">回执处理</el-tag></span>
            <span v-if="scope.row.msstatus=== '9'"><el-tag type="warning">消息阻塞</el-tag></span>
            <span v-if="scope.row.msstatus=== '10'"><el-tag type="warning">阻塞中断</el-tag></span>
            <span v-if="scope.row.msstatus=== '11'"><el-tag type="warning">已被丢弃</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column label="操作报文时间" :formatter="dateFormat" prop="msotime" align="center"
                         show-overflow-tooltip></el-table-column>
        <el-table-column label="发送者ID" prop="sr_defn" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span><el-tag type="success">{{scope.row.sr_defn}}</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column label="接收者ID" prop="rr_defn" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <span><el-tag type="success">{{scope.row.rr_defn}}</el-tag></span>
          </template>
        </el-table-column>
        <el-table-column label="业务类型" prop="mstype" align="center" show-overflow-tooltip width="150"></el-table-column>
        <el-table-column label="重发次数" prop="msrenum" width="80" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination background :page-size.sync="pageTable.size" :current-page.sync="pageTable.curr" :total="pageTable.total"/>
    </Panel>

    <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="content.show" title="查看报文内容" width="600px">
      <div v-if="content.show">
        <FileContent v-if="content.show" :content="content"></FileContent>
      </div>
    </el-dialog>

    <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="sendop.show" title="重发选项">
      <div v-if="sendop.show">
        <ReSendOp v-if="sendop.show" ref="ReSendOp" :filePathArray="patharray"></ReSendOp>
      </div>
    </el-dialog>

<!--    <el-dialog close-on-press-escape append-to-body v-draggable :visible.sync="QRCodeShow.show" width="150px" title="二维码" >-->
<!--      <div v-if="QRCodeShow.show">-->
<!--          <el-image-->
<!--            style="width: 100px; height: 100px"-->
<!--            :src="this.QRCodeShow.url"-->
<!--            fit="cover"></el-image>-->
<!--        </div>-->
<!--    </el-dialog>-->

  </div>
</template>
<script>
  import perApi from "@/api/filepersistent/Filepersistent";
  import FileContent from "./FileContent";
  import ReSendOp from "./ReSendOp";
  import {config} from "cnetong-core-frontend";
  import {PageTable} from 'cnetong-core-frontend';

  let moment = require("moment");
  export default {
    name: "FilePersistent",
    components: {FileContent, ReSendOp},
    data() {
      return {
        pageTable: new PageTable({
          size: 10,
          autoLoad: true,
          doLoad: perApi.selectTable,
          param: {
            date: moment().format("YYYY-MM-DD"),
            start_time: String(moment().hour()),
            end_time: String(moment().hours() + 1),
            start_minute: '0',
            end_minute: '59',
          }
        }),
        translate:[
          {
            "value":"1",
            "label":"申报"
          },
          {
            "value":"2",
            "label":"回执"
          },
          {
            "value":"3",
            "label":"未知"
          },
        ],
        patharray: [],
        transOptions: [],
        dateOptions: [],
        timeOptions: [],
        minuteOptions: [],
        dataTable: [],
        pathList: [],
        message: "",
        sendop: {
          show: false
        },
        params: {
          filePathArray: []
        },
        multipleSelection: [],
        content: {
          show: false,
          info: "",
          trans: ""
        },
        QRCodeShow:{
          show: false,
          url:"",
        }

      };
    },
    mounted() {
      perApi.transSelect().then(respData => {
        this.transOptions = respData.datarows;
      });
      perApi.dateSelect().then(respData => {
        this.dateOptions = respData.datarows;
        // this.queryform.date = moment().format("YYYY-MM-DD");
      });
      perApi.timeSelect().then(respData => {
        this.minuteOptions = respData.minuteList;
        this.timeOptions = respData.hourList;
      });
    },
    methods: {
      queryCheck() {
        if (
          Number(this.pageTable.param.end_time) * 60 +
          Number(this.pageTable.param.end_minute) <
          Number(this.pageTable.param.start_time) * 60 +
          Number(this.pageTable.param.start_minute)) {
          this.$message.warning("开始时间不能大于结束时间，请重新选择");
          return;
        }
        this.doQuery();
      },
      async doQuery(params) {
        let resp = perApi.selectTable(this.queryform);
        this.message = resp.message;
        if (this.message) {
          if (this.dataTable.length > 0) {
            this.$message.warning("由于文件过多,只显示部分筛选结果,请精确查询条件缩小筛选范围！");
          } else {
            this.$message.warning("由于文件过多,还未搜索到目标文件,请手动到以下还未搜索过的目录：" + this.pathList.join(',') + " 中继续查找！");
          }
        }
      },
      // 删除
      async doSeleDel() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择数据！");
          return;
        }
        try {
          await this.confirm();
          this.pageTable.isLoading = true;
          let array = []
          this.multipleSelection.forEach(value => {
            array.push(value.filePath)
          })
          await perApi.del(array);
          this.pageTable.handleLoad();
        } finally {
          this.pageTable.isLoading = false;
        }
      },
      // 重发
      async doSeleReSend(index, row) {
        if (this.multipleSelection.length === 0) {
          this.$message.warning("请选择数据！");
          return;
        }
        try {
          await this.confirm();
          this.pageTable.isLoading = true;
          let array = []
          this.multipleSelection.forEach(value => {
            array.push(value.filePath)
          })
          await perApi.reSendMessage(array).then(()=>{
            this.pageTable.handleLoad();
          });
        } finally {
          this.pageTable.isLoading = false;
        }
      },
      //格式化时间戳
      dateFormat(row, column, value) {
        return value && moment(value).format("YYYY-MM-DD HH:mm:ss");
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //查询报文内容
      fileContent(index, row) {
        perApi.fileContent(encodeURI(row.filePath)).then(respData => {
          this.content.trans = respData.content.trans;
          this.content.info = respData.content.info;
          this.content.show = true;
        });
      },
      // 同时下载业务原文和传输文件
      async download(index, row) {
        var url =
          config.ajaxUrl + "/aseapi/console/systemmgr/filepersist/download";
        //创建form
        var temp = document.createElement("form");
        temp.action = url;
        //get请求
        temp.method = "get";
        //创建input
        var opt = document.createElement("input");
        opt.name = "path";
        //input传uuid
        opt.value = row.filePath;
        temp.appendChild(opt);
        //隐藏form
        temp.style.display = "none";
        document.body.appendChild(temp);
        //提交表单
        temp.submit();
        //移除
        document.body.removeChild(temp);
      },
      // 展示二维码
      async showQRcode(index, row){
        await perApi.getQRCode(encodeURI(row.filePath)).then(respData => {
          this.QRCodeShow.show = true;
          this.QRCodeShow.url ="data:image/jpg;base64,"+respData.data;
        });
      }
    },

  };
</script>
<style lang="scss" scoped>
  .el-form-item__content {
    height: 41px !important;
  }
</style>


